import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetImport2CrmOptions as GetImport2CrmOptionsQuery,
    GetImport2CrmOptions_import2CrmOptions as Option,
} from 'nutshell-graphql-types';

import GET_CRM_OPTIONS from '../queries/get-import2-crm-options.graphql';

type Return = {
    isLoading: boolean;
    crmOptions: Option[] | null | undefined;
    errorMessage: string | null | undefined;
};

export const useGetImport2CrmOptions = (): Return => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetImport2CrmOptionsQuery, Record<any, any>>(GET_CRM_OPTIONS, {
        fetchPolicy: 'cache-and-network',
    });

    const crmOptions = data ? data.import2CrmOptions : null;

    const filteredOptions = crmOptions ? crmOptions.filter((crm) => crm.type !== 'NUTSHELL') : [];

    return {
        isLoading,
        crmOptions: filteredOptions,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
